import dataBase from '../dataBase/database'
// import axios from 'axios'
import { projectService } from './project.service' 
import { networkService } from './network.service'
import { tradepointService } from './tradepoint.service'
import { categoryService } from './category.service'
import { productService } from './product.service'
import { config } from '@/_helpers'
import { reportService } from './report.service'

export default {
  async prefetchAll(projectId) {
    if (!navigator.onLine) return
    try {
      let data = await reportService.getAllData(projectId)
      console.log(data);
      
      //удаление старых сетей и сохранение новых
      await dataBase.networks.where('projectId').equals(Number(projectId)).delete()
      await dataBase.networks.bulkPut(
        data.networks.map(n => ({
          ...n,
          projectId: Number(projectId),
          synced: 2,
          cachedAt:  new Date().toISOString()
        }))
      )

      //удаление старых категорий и точек
      const oldPoints = await dataBase.points.where('projectId').equals(Number(projectId)).toArray()
      for (const point of oldPoints) {
        await dataBase.categories.where('pointId').equals(String(point.id)).delete()
        await dataBase.points.where('projectId').equals(Number(projectId)).delete()
      }

      //сохранение новых точек и категорий
      await dataBase.points.bulkPut(
        data.points.map(p => ({
          ...p.point,
          synced: 2,
          projectId: Number(projectId),
          networkId: Number(p.networkId),
          cachedAt:  new Date().toISOString()
        }))
      )


      await dataBase.categories.bulkPut(
        data.categories.map(cat => ({
          ...cat,
          pointId: Number(cat.pointId),
          synced: 2,
          cachedAt:  new Date().toISOString()
        }))
      )

      //вставка новых категорий дмп
      await dataBase.dmpCategories.clear()
      await dataBase.dmpCategories.bulkPut(
        data.dmpCategories.map(c => ({ ...c,
          title: c.title, 
          cachedAt: new Date().toISOString() 
        }))
      )

      //сохранение новых мотивационных отчетов
      for(const item of data.motivationalReports) {
        const localId = await dataBase.motivationalReport.put({
          serverId: item.id,
          projectId: String(item.project.id),
          pointId: String(item.tradePoint.id),
          createdAt: item.createDate,
          synced: 2,
          cachedAt: new Date().toISOString(),
        })

        if(item.motivationalDmp && item.motivationalDmp.length) {
          this.loadMotivationalDmp(item.motivationalDmp, localId)
        }
      }

      for(const item of data.products) {
        item.product.hasAction = item.hasAction
        item.product.hasReportData = item.hasReportData
        await dataBase.products.put({
          ...item.product,
          pointId:    String(item.pointId),
          projectId:  String(item.projectId),
          categoryId: String(item.categoryId),
          cachedAt:   new Date().toISOString(),
        })

        const key = `${item.product.id}_${item.pointId}`
        await dataBase.productReportData.put({
          id:        key,
          productId: String(item.product.id),
          pointId:   String(item.pointId),
          projectId: String(item.projectId),
          data:      item.reportData,
          synced:    2,
          cachedAt:  new Date().toISOString(),
        })

        if (item.reportData?.photo?.length) {
          await dataBase.photos.where('reportId').equals(key).delete()
          for (const photo of item.reportData.photo) {
            try {
              const response = await fetch(config.image(photo.uuid))
              const arrayBuffer = await response.arrayBuffer();
              await dataBase.photos.add({
                reportId:     key,
                uuid:         photo.uuid,
                extension:    photo.extension,
                blob:         arrayBuffer,
                synced:       2,
                dmp:          photo.dmp,
                motivational: photo.motivational,
                createdAt:    new Date().toISOString(),
              })
            } catch (e) {
              console.warn(`[prefetchAll] Не удалось скачать фото ${photo.uuid}:`, e)
            }
          }
        } else {
          await dataBase.photos.where('reportId').equals(key).delete()
        }
      }

      console.log('[DataService] prefetchAll завершён')
    } catch (e) {
      console.error('[DataService] prefetchAll ошибка:', e)
    }
  },

  async loadMotivationalDmp(motivationalDmp, motivationalReportId) {
    for (let dmp of motivationalDmp) {
      try {
        let existing = await dataBase.motivationalDmp.where('serverId').equals(dmp.id).first()

        if (existing) {
          await dataBase.motivationalDmp.update(existing.id, {
            dmpCategory:          dmp.dmpCategory,
            comment:              dmp.comment,
            localMotivationalReportId: Number(motivationalReportId),
            serverId:             dmp.id,
            synced:               2,
            cachedAt:             new Date().toISOString(),
          })
        } else {
          await dataBase.motivationalDmp.add({
            dmpCategory:          dmp.dmpCategory,
            comment:              dmp.comment,
            localMotivationalReportId: Number(motivationalReportId),
            serverId:             dmp.id,
            synced:               2,
            createdAt:            new Date().toISOString(),
          })
        }
        if(dmp.motivationalDmpReports && dmp.motivationalDmpReports.length) {
          for(const report of dmp.motivationalDmpReports) {
            let localDmp = await dataBase.motivationalDmp.where('serverId').equals(Number(dmp.id)).first()
            await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(localDmp.id)).delete()
            await dataBase.photos.where('reportId').equals(`${localDmp.localMotivationalReportId}_${localDmp.id}`).delete()
            if(new Date(report.sendDate).getDate() == new Date().getDate()) {
              await dataBase.motivationalDmpReport.add({
                localDmpId: Number(localDmp.id),
                dmpCategory: report.dmpCategory,
                synced: 2,
                cachedAt: new Date().toISOString()
              })

              if(report.reportPhotos && report.reportPhotos.length) {
                for (const photo of report.reportPhotos) {
                  const response = await fetch(config.image(photo.uuid))
                  const arrayBuffer = await response.arrayBuffer();
                  await dataBase.photos.add({
                    reportId: `${localDmp.localMotivationalReportId}_${localDmp.id}`,
                    uuid: photo.uuid,
                    extension:  photo.extension,
                    blob: arrayBuffer,
                    synced: 2,
                    dmp: photo.dmp,
                    motivational: photo.motivational,
                    createdAt:  new Date().toISOString(),
                  })
                }
              }
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  },

  async getProjects() {
    if (navigator.onLine) {
      try {
        let data = await projectService.getMyProjects()
        await dataBase.projects.clear()
        await dataBase.projects.bulkPut(
          data.map(p => ({ ...p, 
            cachedAt: new Date().toISOString() 
          }))
        )
        return data
      } catch (e) {
        console.log(e);
        
        console.warn('[DataService] getProjects: нет ответа, берём кэш')
      }
    }
    return dataBase.projects.toArray()
  },

  async loadProject(projectId) {
    if(navigator.onLine) {
      try {
        let project = await projectService.loadProject(projectId)
        await dataBase.projects.put({ ...project, 
          cachedAt: new Date().toISOString() 
        })
        return project
      } catch(e) {
        console.warn('[DataService] loadProject: нет ответа, берём кэш')
      }
    }
    return dataBase.projects.get(Number(projectId))
  },

  // ─── СЕТИ ───────────────────────────────────────────────────────

  async getNetworks(projectId) {
    if (navigator.onLine) return await networkService.loadMyNetwork(projectId)
    return dataBase.networks.where('projectId').equals(Number(projectId)).toArray()
  },

  async loadNetwork(networkId, projectId) {
    if (navigator.onLine) {
      try {
        let network = await networkService.loadNetwork(networkId)
        // await dataBase.networks.put({
        //   ...network,
        //   projectId: Number(projectId),
        //   synced: 2,
        //   cachedAt: new Date().toISOString()
        // })
        return network
      } catch (e) {
        console.warn('[DataService] loadNetwork: нет ответа, берём кэш', e)
      }
    }
    return dataBase.networks.where('[id+projectId]').equals([Number(networkId), Number(projectId)]).first()
  },

  // ─── ТОЧКИ ──────────────────────────────────────────────────────

  async getPoints(projectId, networkId) {
    if (navigator.onLine) return await tradepointService.getmytradepoints(projectId, networkId)
    return dataBase.points.where('[networkId+projectId]').equals([Number(networkId), Number(projectId)]).toArray()
  },

  async loadTradePoint(pointId) {
    if (navigator.onLine) {
      try {
        let tradePoint = await tradepointService.loadPoint(pointId)
        // let oldPoint = await dataBase.points.get(Number(pointId))
        // await dataBase.points.put({ ...tradePoint,
        //   projectId: oldPoint.projectId, 
        //   networkId: oldPoint.networkId, 
        //   cachedAt: new Date().toISOString() })
        return tradePoint
      } catch (e) {
        console.warn('[DataService] getTradePoint: нет ответа, берём кэш')
      }
    }
    
    return dataBase.points.get(Number(pointId))
  },

  // ─── Категории ───────────────────────────────────────────────────

  async getCategories(pointId, projectId) {
    if (navigator.onLine) {
      try {
        let data = await categoryService.getpointcategories(pointId, projectId)
        // await dataBase.categories.where('pointId').equals(pointId).delete()
        // await dataBase.categories.bulkPut(
        //   data.map(p => ({ ...p, 
        //     pointId: pointId,
        //     cachedAt: new Date().toISOString() 
        //   }))
        // )
        return data
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.categories.where('pointId').equals(Number(pointId)).toArray()
  },

  async loadCategory(categoryId, pointId) {
    if (navigator.onLine) {
      try {
        let category = await categoryService.loadCategory(categoryId)
        // let oldCategory = dataBase.categories.get(Number(categoryId))
        // await dataBase.categories.put({ ...category,
        //   pointId: oldCategory.pointId,
        //   cachedAt: new Date().toISOString() 
        // })
        return category
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    console.log(dataBase.categories.where('[id+pointId]').equals([Number(categoryId), Number(pointId)]).first());
    
    return dataBase.categories.where('[id+pointId]').equals([Number(categoryId), Number(pointId)]).first()
  },

  // ─── ПРОДУКТЫ ───────────────────────────────────────────────────

  async getActionProducts(projectId, pointId) {
    if (navigator.onLine) {
      try {
        // await dataBase.products.where('[categoryId+pointId]').equals(["a", pointId]).delete()
        let data = await productService.loadPointActionProducts(projectId, pointId)
        // await dataBase.products.bulkPut(
        //   data.map(p => ({ ...p, 
        //     pointId: pointId, 
        //     categoryId: "a",
        //     cachedAt: new Date().toISOString() 
        //   }))
        // )
        return data
      } catch (e) {
        console.warn('[DataService] getProducts: нет ответа, берём кэш')
      }
    }
    let products = await dataBase.products.where('[categoryId+pointId]').equals(["a", String(pointId)]).toArray()
    if(products && products.length) {
      for(const product of products) {
        const key = `${product.id}_${product.pointId}`
        let reportData = await dataBase.productReportData.get(key)
        product.reportData = reportData
        let field = reportData.data.reportFieldWithData.find(el => el.name == "Остаток")
        if(field && field.value != null) {
          product.hasReportData = true
        }
      }
    }
    return products
  },

  async getPointProducts(projectId, pointId, categoryId) {
    if (navigator.onLine) {
      try {
        // await dataBase.products.where('[categoryId+pointId]').equals([categoryId, pointId]).delete()
        let data = await productService.loadPointProducts(projectId, pointId, categoryId)
        // await dataBase.products.bulkPut(
        //   data.map(p => ({ ...p, 
        //     pointId: pointId,
        //     categoryId: categoryId, 
        //     cachedAt: new Date().toISOString() 
        //   }))
        // )
        return data
      } catch (e) {
        console.warn('[DataService] getPointProducts: нет ответа, берём кэш')
      }
    }
    let products = await dataBase.products.where('[categoryId+pointId]').equals([String(categoryId), String(pointId)]).toArray()
    if(products && products.length) {
      for(const product of products) {
        const key = `${product.id}_${product.pointId}`
        let reportData = await dataBase.productReportData.get(key)
        product.reportData = reportData
        let field = reportData.data.reportFieldWithData.find(el => el.name == "Остаток")
        if(field && field.value != null) {
          product.hasReportData = true
        }
        
      }
    }
    return products
  },

  async countPointActionProducts(projectId, pointId) {
    if(navigator.onLine) {
      try {
        // await dataBase.countActionsProduct.where('pointId').equals(pointId).delete()
        let data = await productService.countPointActionProducts(projectId, pointId)
        // await dataBase.countActionsProduct.put({
        //   id: pointId,
        //   count: data,
        //   cachedAt: new Date().toISOString()
        // })
        return data
      } catch (e) {
        console.warn('[DataService] countPointActionProducts: нет ответа, берём кэш')
      }
    }
    return dataBase.countActionsProduct.where('pointId').equals(pointId).first()
  },


  async getProductReportData(projectId, pointId, productId) {
    if (navigator.onLine) {
      try {
        let data = await productService.getProductReportData(projectId, pointId, productId)
        // await dataBase.productReportData.put({
        //   id:`${productId}_${pointId}`,
        //   productId: String(productId),
        //   pointId : String(pointId),
        //   data: data,
        //   synced: 1,
        //   cachedAt:  new Date().toISOString(),
        // })
        // if(data.photo && data.photo.length) {
        //   await dataBase.photos.where('reportId').equals(`${productId}_${pointId}`).delete()
        //   for (const photo of data.photo) {
        //     const response = await fetch(config.image(photo.uuid))
        //     const blob = await response.blob()
        //     await dataBase.photos.add({
        //       reportId: `${productId}_${pointId}`,
        //       uuid: photo.uuid,
        //       extension:  photo.extension,
        //       blob: blob,
        //       synced: 1,
        //       dmp: photo.dmp,
        //       motivational: photo.motivational,
        //       createdAt:  new Date().toISOString(),
        //     })
        //   }

        // } else {
        //   await dataBase.photos.where('reportId').equals(`${productId}_${pointId}`).delete()
        // }
        return data
      } catch (e) {
        console.log(e);
        console.warn('[DataService] getProductReportData: нет ответа, берём кэш')
      }
    }
    const cached = await dataBase.productReportData.get(`${productId}_${pointId}`)
    if(cached) {
      cached.data.photo = []
      const photos = await dataBase.photos.where('reportId').equals(String(cached.id)).toArray()
      if(photos.length) {
        for (const photo of photos) {
          cached.data.photo.push(photo)
        }
      }
      
    }
    return cached ? cached.data : null
  },
}